import React, {createContext, useCallback, useContext, useState} from 'react'
import {
    NaturalReferencingPageSpeedDataResponse,
    initialValuesNaturalReferencingPageSpeedResponse,
    NaturalReferencingPageSpeedResponse,
} from '../../../@types'
import {Get} from '../../../../setup'
import {TransformPageSpeedResponse} from '../../../pages/natural-referencing'
import {usePageSpeedData} from '../../../features'

const PAGE_SPEED_REFRESH = process.env.REACT_APP_STATISTICS_PAGE_SPEED_REFRESH || 'page-speed/refresh-data'

interface PageSpeedContextProps {
    data: NaturalReferencingPageSpeedDataResponse
    refreshPageSpeed: () => Promise<void>
    loading: boolean
}

const PageSpeedContext = createContext<PageSpeedContextProps | undefined>(undefined)

export const PageSpeedProvider: React.FC<{children: React.ReactNode}> = ({children}) => {

    const [data, setData] = useState<NaturalReferencingPageSpeedDataResponse>(initialValuesNaturalReferencingPageSpeedResponse)
    const [loading, setLoading] = useState(false)
    usePageSpeedData({setData})

    const refreshPageSpeed = useCallback(async () => {
        setLoading(true)

        try {
            const response = await Get<NaturalReferencingPageSpeedResponse>({endpoint: PAGE_SPEED_REFRESH})
            if (response) {
                setData(TransformPageSpeedResponse(response.pageSpeedData));
            }
        } catch (error) {
            console.error('Error refreshing page speed:', error)
        } finally {
            setLoading(false)
        }
    }, [])

    return (
        <PageSpeedContext.Provider value={{data, loading, refreshPageSpeed}}>
            {children}
        </PageSpeedContext.Provider>
    )
}

export const usePageSpeed = () => {
    const context = useContext(PageSpeedContext)
    if (!context) {
        throw new Error('usePageSpeed must be used within a PageSpeedProvider')
    }
    return context
}